var PageBuilderConstants = {

  INIT:              'init',
  CHANGE_EVENT:      'changeEvent',
  CHANGE_MODE:       'changeMode',
  CHANGE_TAB:        'changeTab',
  CHANGE_ROLES:      'changeRoles',

  FOCUS_EDITOR:      'focusEditor',
  BLUR_EDITOR:       'blurEditor',
  SAVE_EDITOR:       'saveEditor',

  // row and column actions
  ADD_COLUMN:        'addColumn',
  ADD_ROW:           'addRow',
  DUPLICATE_ROW:     'duplicateRow',
  DELETE_COLUMN:     'deleteColumn',
  DELETE_ROW:        'deleteRow',
  RESET_COLUMN:      'resetColumn',
  MOVE_ROW:          'moveRow',
  RESIZE_ROW:        'resizeRow',
  RESIZE_COLUMN:     'resizeColumn',
  TOGGLE_VISIBILITY: 'toggleVisibility',
  HIGHLIGHT_ROW:     'highlightRow',
  HIGHLIGHT_COLUMN:  'highlightColumn',
  SET_CONTENT_TYPE:  'setContentType',
  SET_CHART:         'setChart',
  SET_NAME:          'setName',
  SET_WIDGET:        'setWidget',

  // rich text editor actions
  SAVE:             'save',
  HELP:             'help',
  CANCEL:           'cancel',
  INSERT_IMAGES:    'insertImages',
  INSERT_CALENDAR:  'insertCalendar',
  STYLE_COLUMN:     'styleColumn',
  PADDING:          'padding',
  MARGIN:           'margin',
  BORDER:           'border',
  BACKGROUND_COLOR: 'backgroundColor',
  EVENT:            'event',
  AVAILABILITY:     'availability',

  // forms
  INSERT_FORM:                'insertForm',
  INSERT_TEXT_VARIABLE:       'insertTextVariable',
  SELECT_DATES_FORM:          'SelectDatesForm',
  GUEST_INFORMATION_FORM:     'GuestInformationForm',
  SELECT_ACCOMODATIONS_FORM:  'SelectAccommodationsForm',

  // menu
  OPEN_ROW_MENU:     'openRowMenu',
  CLOSE_ROW_MENU:    'closeRowMenu',

  // view modes
  COMPOSE: 'compose',
  DESKTOP: 'desktop',
  TABLET:  'tablet',
  PHONE:   'phone',
  CELL:    'cell',

  // directions
  ABOVE:  'above',
  BELOW:  'below',
  UP:     'up',
  DOWN:   'down',
  LEFT:   'left',
  RIGHT:  'right',
  TOP:    'top',
  BOTTOM: 'bottom',

  ALL:  'all',
  NONE: 'none'

};

export default PageBuilderConstants
